module.exports = __webpack_public_path__ + "img/section2_img5.16d6f258.png";